import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Body, Footer, Popup } from '@calendly/ui/components/popup';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { USER_GROUP_TYPE } from './constants';
import { unassignPopupOwnerTypeSelector } from './selectors';
import { deleteManagedEventTypeMemberships } from './slice';
const paragraphCss = "p1f0lp1p";
const Paragraph = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(paragraphCss, props.className)} />;
});
const boldCss = "b1097hv3";
const Bold = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(boldCss, props.className)} />;
});
export const UnassignPopup = ({
  isOpen,
  submitting,
  onClose,
  id
}) => {
  const params = useParams();
  if (!id) {
    id = params.id;
  }
  const dispatch = useDispatch();
  const handleSubmit = () => dispatch(deleteManagedEventTypeMemberships({
    managedEventTypeId: id
  }));
  const ownerType = useSelector(unassignPopupOwnerTypeSelector);
  return <Popup isOpen={isOpen} onClose={onClose} title={I18n.t('publisher.organization.managed_event_types.assign.unassign_popup.title')}>
      <Body>
        <Paragraph>
          {ownerType === USER_GROUP_TYPE ? I18n.t('publisher.organization.managed_event_types.assign.unassign_popup.line_1_group') : I18n.t('publisher.organization.managed_event_types.assign.unassign_popup.line_1')}
        </Paragraph>
        {ownerType !== 'OrganizationInvitation' && <Paragraph>
            {HtmlParser(I18n.t('publisher.organization.managed_event_types.assign.unassign_popup.line_2'), {
          Bold
        })}
          </Paragraph>}
      </Body>
      <Footer>
        <Button decoration="secondary-outline" onClick={onClose}>
          {I18n.t('publisher.action.cancel')}
        </Button>
        <Button onClick={handleSubmit} loading={submitting}>
          {I18n.t('publisher.action.yes')}
        </Button>
      </Footer>
    </Popup>;
};

require("./unassign_popup.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./unassign_popup.js");